export default {
  tickets: 'Tickets',
  permissions: 'Permissões',
  warroom: 'War-Room',
  sac: 'SmartCare',
  performance: 'Métricas Proprietárias',
  modules: 'Módulos',
  ojesed: 'Admin Tools',
};
